<template>
  <span class="sd-starpill"><span class="st">{{ stars }}</span><span class="num-ltr">{{ score.toFixed(1) }}</span> {{ t('of5') }}</span>
</template>
<script>
import { stars } from '../lib/format.js'
import { sdMixin } from '../store.js'
export default { name: 'SdStarPill', mixins: [sdMixin], props: { score: { type: Number, required: true } }, computed: { stars() { return stars(this.score) } } }
</script>
